import * as prdCtgPrdScript from './_ctg_products.js';
import layzyload from 'layzyload';

window.addEventListener('DOMContentLoaded', function(){
	prdCtgPrdScript.init();
});

